module.exports = __webpack_public_path__ + "media/svg/tl-b96718d8.svg";